var map = {
	"./american-express.svg": 1234,
	"./aura.svg": 6254,
	"./banescard.svg": 5752,
	"./cabal.svg": 6976,
	"./diners-club.svg": 4453,
	"./discover.svg": 310,
	"./elo.svg": 631,
	"./hiper.svg": 5711,
	"./hipercard.svg": 9850,
	"./jcb.svg": 4812,
	"./maestro.svg": 9702,
	"./mastercard.svg": 9403,
	"./visa-electron.svg": 6139,
	"./visa.svg": 1516
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1851;